import { UI, HStack, Stack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import React, { useEffect } from 'react';

import { OperationType } from '../../../../../../../../../components/OperationType';
import { TableContentItemText } from '../../../../../../../../../components/TableContent';
import { useFixedIncomeSellAssetController } from '../../../../../hooks/products/FixedIncomeSell';
import { LateralBar } from '../../../components/LateralBar';

import { FixedIncomeItemSelectedTypes } from '.';

export const FixedIncomeItemSelectedDesktop: React.FC<FixedIncomeItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
}) => {
  const id = offer.productIdNormalized;
  const {
    amountItem,
    handleChangeAmountItem,
    errorMessage,
    hasError,
    netFinancialValue,
    netFinancialValueFormatted,
  } = useFixedIncomeSellAssetController(offer);

  useEffect(() => {
    if (offer.orderQuantity === amountItem || !amountItem) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderQuantity: amountItem || 0,
      orderValue: netFinancialValue,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountItem]);

  return (
    <UI.List testId="selected-product" height={120}>
      <LateralBar
        backgroundColor={Color['product.rf']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <HStack flex={1} justifyContent="space-between">
        <UI.ListItem testId="selected-product-name" title="Produto" stackProps={{ maxW: '1/6' }}>
          <TableContentItemText noOfLines={2} tooltip={offer.issuerFullName}>
            {offer.issuerFullName}
          </TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-type" title="Tipo">
          <OperationType title="Resgate" />
        </UI.ListItem>
        <UI.ListItem testId="selected-product-quantity-available" title="Quantidade disponível">
          <TableContentItemText>{offer.availableQuantityNormalized}</TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-ir" title="IR">
          <TableContentItemText>{offer.irFormatted}</TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-net-value" title="Valor líquido">
          <TableContentItemText>{netFinancialValueFormatted}</TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-name" title="Quantidade solicitada">
          <Stack pr={Spacing['inline.xxxs']} w="222px">
            <UI.InputStepper
              stepperValue={1}
              max={offer.availableAmount}
              min={1}
              name={`fixed-income-amount-order-input-${id}`}
              keyboardType="numeric"
              fontSize={Typography['fontsize.md']}
              defaultValue={amountItem || 0}
              onChange={handleChangeAmountItem}
              showErrorMessage={false}
              {...(hasError && {
                customError: errorMessage,
                showErrorMessage: true,
              })}
            />
          </Stack>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-availableInAccount" title="Disponível em conta">
          <TableContentItemText>{offer.availableInAccountNormalized}</TableContentItemText>
        </UI.ListItem>
      </HStack>
    </UI.List>
  );
};
